import { ChangeDetectionStrategy, Component, ChangeDetectorRef, OnInit, Input, OnChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { NotificationSearchService } from '../../notification/notification-search/notification-search.service';
import { NotificationFilterService } from '../../notification/notification-filter/notification-filter.service';
import { debounceTime, catchError } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { FilterOptions } from '../notification-filter/notification-filter.component';
import { MatDialog } from '@angular/material/dialog';
import { UniqueIdDialogComponent } from '../unique-id-dialog/unique-id-dialog.component';
import { Router } from '@angular/router';
import { statusIcon } from '../../constants';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';

@Component({
  selector: 'dl-notification-table',
  templateUrl: './notification-table.component.html',
  styleUrls: ['./notification-table.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NotificationTableComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  @Input() public tableData = []; 
  public fileData = [];
  public columnData: any;
  public displayedColumns = ['Type', 'GlobalId', 'LocalId', 'Country', 'Title', 'CreationDate','Status'];
  public dataSource = new MatTableDataSource<any>(this.tableData);
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public filterArray: any[] = [];
  public notificationStatusIcon: {};
  public userPermission: any;
  public initPageLoad = true;
  
  constructor(
    private router: Router, 
    private appUtil: AppUtils, 
    private readonly oneSnackBar: OneSnackBarService, 
    private _QnSbnService:QnSbnService, 
    private _QnSbnDataService:QnSbnDataService, 
    private notificationFilterService: NotificationFilterService, 
    private notificationSearchService: NotificationSearchService, 
    private _cdr: ChangeDetectorRef, 
    private readonly dialog?: MatDialog
  ) {}

  public ngOnInit(): void {
    this.notificationStatusIcon = statusIcon;
    this.userPermission = this._QnSbnService.getUserData();
    const allNotificationData = this._QnSbnService.getNotificationData();
    this.sort.sort(({ id: 'CreationDate', start: 'desc'}) as MatSortable);
    this.dataSource.sort = this.sort;
    if(sessionStorage.getItem('reloadOverview') == 'true' || !allNotificationData || allNotificationData.length < 0) {
      this.getTableData(['all'], ['all'], ['all']);
    } else {
      if(Array.isArray(allNotificationData)) {
        this.tableData = allNotificationData[0].notificationOverview || [];
      } else {
        this.tableData = allNotificationData.notificationOverview || [];
      }
      sessionStorage.setItem('reloadOverview', 'false');
      this.dataSource.data = this.tableData;
      if(this.tableData.length > 0) {
        this.tableData.forEach(value => {
          this.notificationFilterService.setTypeName(value.Type);
          this.notificationFilterService.setStatusName(value.Status);
          this.notificationFilterService.setStatusName('Completed');
          this.notificationFilterService.setCountryName(value.Country);
        });
      }
    }
    this.notificationSearchService.searchData$.subscribe(searchValue => {
      this.dataSource.filter = searchValue;
      this.dataSource.filterPredicate = (data: any, filter: string) => {
        // return data.Type.toLowerCase().includes(filter.toLowerCase()) || data.LocalId.toLowerCase().includes(filter.toLowerCase()) || data.Title.toLowerCase().includes(filter.toLowerCase()) || data.Status.toLowerCase().includes(filter.toLowerCase());
        return this.appUtil.getLowerCase(data.Type).includes(filter.toLowerCase()) || this.appUtil.getLowerCase(data.LocalId).includes(filter.toLowerCase()) || 
        this.appUtil.getLowerCase(data.Title).includes(filter.toLowerCase()) || this.appUtil.getLowerCase(data.Country).includes(filter.toLowerCase()) || this.appUtil.getLowerCase(data.Status).includes(filter.toLowerCase());
      };
      this.initPageLoad = false;
      this._cdr.detectChanges();
    });
    this.notificationFilterService.filterData$.pipe(debounceTime(500)).subscribe(filterValue => {

      if(filterValue.typeFilters.length <= 0 ){
        filterValue.typeFilters = ['all'];
      }
      if(filterValue.statusFilters.length <= 0 ){
        filterValue.statusFilters = ['all'];
      }
      if( filterValue.countryFilters.length <= 0 ){
        filterValue.countryFilters = ['all'];
      }
      
      this.getTableData(filterValue.typeFilters, filterValue.statusFilters, filterValue.countryFilters);
    });
  }

  public getTableData(type, status, country){
    this._QnSbnService.getNotificationOverviewData(type, status, country).subscribe(data=>{      
      this._QnSbnService.setNotificationData(data);
      // @ts-ignore
      this.tableData = data.notificationOverview;
      this.dataSource.data = this.tableData;
      this.tableData.forEach(value => {
        this.notificationFilterService.setTypeName(value.Type);
        this.notificationFilterService.setStatusName(value.Status);
        this.notificationFilterService.setStatusName('Completed');
        this.notificationFilterService.setCountryName(value.Country);
        if(this.tableData.length < 1) {
          this.initPageLoad = false;
        }
      });
    },
    (error: HttpErrorResponse) => {
      // console.log("error",error);
      this._QnSbnService.httpErrorHandler(error, 'Something went worng. Please try again.');
    });
  }
  
  public filterSourceTable(filterValue: any) {
    if (filterValue.typeFilters.length < 1 && filterValue.statusFilters.length < 1 && filterValue.countryFilters.length < 1 && filterValue.searchText === '') {
      this.dataSource.data = this.tableData;
    } else {
      const typeFilterArray = this.tableData.filter(data => 
        filterValue.typeFilters.includes(data.Type) 
        || filterValue.typeFilters.length === 0);

      const statusFilterArray = typeFilterArray.filter(data => 
        filterValue.statusFilters.includes(data.Status) 
        || filterValue.statusFilters.length === 0);

      const countryFilterArray = statusFilterArray.filter(data => 
        filterValue.countryFilters.includes(data.Country) 
        || filterValue.countryFilters.length === 0);

      const searchString = filterValue.searchText;

      this.dataSource.data = countryFilterArray.filter(data => 
      this.appUtil.getLowerCase(data.Type).includes(searchString.toLowerCase()) 
      || this.appUtil.getLowerCase(data.LocalId).includes(searchString.toLowerCase()) 
      || this.appUtil.getLowerCase(data.Title).includes(searchString.toLowerCase()) 
      || this.appUtil.getLowerCase(data.Status).includes(searchString.toLowerCase())
      || this.appUtil.getLowerCase(data.Country).includes(searchString.toLowerCase()) 
      || searchString === '');


      // this.dataSource.data = statusFilterArray.filter(data => data.LocalId.includes(searchString) || data.Title.includes(searchString) || searchString === '');
    }
    this.initPageLoad = false;
    this._cdr.detectChanges();
  }

  public isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numDisabled = this.dataSource.data.filter(row => row.disabled).length;
    const numRows = this.dataSource.data.length;
    return numSelected + numDisabled === numRows;
  }

  public masterToggle(): void {
    this.isAllSelected() ? this.selection.clear() : this.dataSource.data.forEach(row => (!row.disabled ? this.selection.select(row) : ''));
  }
  
  openLocalNotificationDialog() {
    this.router.navigateByUrl('/create-local-notification');
  }

  openNotificationDetails(row) {
    // console.log('Whole some row:--',row);
    sessionStorage.setItem('reloadOverview','true');
    if(row.Status == 'Draft' && (this.userPermission.CreateNotification || this.userPermission.SendNotification)) {
      this._QnSbnDataService.resetAll();
      this._QnSbnService.getNotificationContactDetails(row.NotificationId).subscribe(
        (newdata:any) => {
          if(newdata.length > 0) {
            const recipientData = []
            newdata.forEach(element => {
              recipientData.push({
                customerId: element.CustomerId,
                customerName: element.CustomerName,
                customerContactName: element.CustomerContactName,
                customerEmail: element.CustomerContactEmail,
                sourceName: element.DataSource
              });
            });
            const sourceName = [...new Set(newdata.map(x => x.DataSource))];

            let sourceEle = [];
            sourceName.forEach(source => {
              sourceEle.push({label: source, value: source})
            });
            this._QnSbnDataService.getMappedQnsbnData({ 
              recipientTable: recipientData,
              sourceName: sourceEle
            },"Recipient")
          }
        },
        (error: HttpErrorResponse) => {
          this._QnSbnService.httpErrorHandler(error, 'Could not fetch contact details.');
          // console.log('error:',error);
        }
      );

      this._QnSbnService.setLocalNotificationID(row.LocalId);
      this._QnSbnDataService.getMappedQnsbnData(row,"DraftNotification");
      this._QnSbnDataService.getMappedQnsbnData(
        {
          "NotificationId": row.NotificationId,
          "Type": row.Type,
          "Title": row.Title,
          "GlobalId": row.GlobalId,
          "Country": row.Country,
          "GlobalNotificationId": row.GlobalNotificationId,
          "CreationDate": row.CreationDate,
          "LocalId": row.LocalId,
          "Status": row.Status,
          "UserId": row.UserId,
          "UserRole": row.UserRole,
          "LocalNotificationLanguage": row.LocalNotificationLanguage
        },"LocalNotificationId");
      if(row.NotificationDocuments && row.NotificationDocuments.length > 0) {
        this._QnSbnDataService.getMappedQnsbnData(row.NotificationDocuments[0],"NotificationDoc");
      }
      if(row.CustomerFeedbackItems) {
        const feedbackData = [];
        row.CustomerFeedbackItems.forEach(element => {
          feedbackData.push({
            dragHandle: '',
            selectType: element.FeedbackItemType,
            selectText: element.FeedbackItemLabel,
            selectMandatory: element.FeedbackItemMandatory || 'Mandatory',
            iconSets: 'more-icon',
            dropDownOpt: element.FeedbackItemDropdown || [],
            radioOpt: element.FeedbackItemRadio || []
          });
        });
        this._QnSbnDataService.getMappedQnsbnData(feedbackData,"ConfigureFeedBack");
      }
      if(row.MessageTitle || row.MessageBody)
        this._QnSbnDataService.getMappedQnsbnData({
          "subjectName":row.MessageTitle,
          "messageAttachmentRTEText":row.MessageBody,
          "templateId": row.TemplateId || ""
        },"MessageAttachment");
      if(row.NotificationAttachments) {
        const fileList = [];
        let fileSize = 0;
        row.NotificationAttachments.forEach(element => {
          const filetype = element.FileName.split('.').pop();
          fileSize = fileSize + element.FileSize;
          if(element.NotificationDoc) {
            this._QnSbnDataService.getMappedQnsbnData([{
              name: element.FileName,
              size: element.FileSize,
              type: filetype,
              fileIcon: this.appUtil.formatFilesIcons(filetype) //"file_" + filetype //+"_Icon"
            }],"NotificationDocFileList");
          } else {
            fileList.push(<any>{
              name: element.FileName,
              size: element.FileSize,
              type: filetype,
              fileIcon: this.appUtil.formatFilesIcons(filetype) //"file_" + filetype //+"_Icon"
            });
          }
        });
        this._QnSbnDataService.getMappedQnsbnData({
          "fileList": fileList,
          "totalAllFileSize": fileSize,
          "fileSizeobject": {}
        },"MessageAttachmentFileList");
      }
      if(row.FeedbackDueDate)
        this._QnSbnDataService.getMappedQnsbnData({
          "feedbackDueDate":row.FeedbackDueDate
        },"FeedbackDueDate");
      const notificationReminders = Array.isArray(row.NotificationReminders) ? row.NotificationReminders : [];
      if(notificationReminders.length > 0) {
        const reminderData = notificationReminders.map(element => ({
          reminderId: element.ReminderId,
          reminderDate: element.ReminderDueDate,
          reminderSubject: element.ReminderSubject,
          reminderMessage: element.ReminderMessage,
          reminderSendMode: element.ReminderSendAutomatically ? '0' : '1',
          reminderSendAutomatically: element.ReminderSendAutomatically,
          reminderSendStatus: element.ReminderSendStatus || 'Not Sent',
          reminderAddTemplate: element.ReminderAddTemplate || '',
          reminderActionIcons: true
        }));
        this._QnSbnDataService.getMappedQnsbnData({
          "remindersData": reminderData
        },"NotificationReminders");
      } else {
        this._QnSbnDataService.getMappedQnsbnData({
          "remindersData": []
        },"NotificationReminders");
      }
      const dueDateToggle = row.DueDateEnabled ?? row.dueDateEnabled;
      if(typeof dueDateToggle === 'boolean') {
        this._QnSbnDataService.setDDToggle(dueDateToggle);
      }
      const feedbackToggle = row.FeedbackEnabled ?? row.feedbackEnabled;
      if(typeof feedbackToggle === 'boolean') {
        this._QnSbnDataService.setFBToggle(feedbackToggle);
      }
      // sessionStorage.setItem('reloadOverview','true');
      this.router.navigateByUrl('/create-notification', { state: { notificationData: row } });
    } else {
      const notificationId = row.NotificationId;
      const notificationReminders = Array.isArray(row.NotificationReminders) ? row.NotificationReminders : [];

      const contacts$ = this._QnSbnService.getNotificationContactDetails(notificationId).pipe(
        catchError((error: HttpErrorResponse) => {
          this._QnSbnService.httpErrorHandler(error, 'Could not fetch contact details.');
          return of([]);
        })
      );
      const accounts$ = this._QnSbnService.getAccountList(notificationId).pipe(
        catchError((error: HttpErrorResponse) => {
          this._QnSbnService.httpErrorHandler(error, 'Could not fetch Account Data');
          return of([]);
        })
      );

      forkJoin({ contacts: contacts$, accounts: accounts$ }).subscribe(result => {
        const contactDataWithReminders = Array.isArray(result.contacts)
          ? result.contacts.map(contact => ({
              ...contact,
              CustomerReminderDetails: contact.CustomerReminderDetails && contact.CustomerReminderDetails.length > 0
                ? contact.CustomerReminderDetails
                : notificationReminders.map(reminder => ({
                    ReminderId: reminder.ReminderId,
                    ReminderDueDate: reminder.ReminderDueDate || '',
                    ReminderSubject: reminder.ReminderSubject || '',
                    ReminderMessage: reminder.ReminderMessage || '',
                    ReminderSendStatus: reminder.ReminderSendStatus || 'Not Sent',
                    ReminderSendAutomatically: reminder.ReminderSendAutomatically
                  }))
            }))
          : result.contacts;

        const accountDataObj = result.accounts && result.accounts.body ? result.accounts.body : result.accounts;

        this.router.navigateByUrl('/notification-details', {
          state: {
            notificationData: row,
            contactData: contactDataWithReminders,
            accountDataObj,
            notificationReminders
          }
        });
      });
    }
  }
}
